export const GENRE = [
    { label: 'Masculino', value: 'Male' },
    { label: 'Feminino', value: 'Female'},
    { label: 'Não-Binário', value: 'NonBinary'},
    { label: 'Outro', value: 'Other'},
];